import type { Options } from '@atlassiansox/cross-flow-support/cross-flow-api-internals';

import { type App } from '../types';

const JOURNEY = 'get-started';
const SOURCE_COMPONENT = 'confluence-home-banner';

export const getCrossflowOptionsForConfluenceHomeBanner: ({
	app,
	sourceContext,
}: {
	app: App;
	sourceContext: string;
}) => Options = ({ app, sourceContext }) => ({
	targetProduct: app.hamsIdentifier,
	journey: JOURNEY,
	sourceComponent: SOURCE_COMPONENT,
	sourceContext,
});
